module.exports = __webpack_public_path__ + "img/Financial_Recall_3_Set.28d7242a.png";